import className from "classnames/bind";
import style from "../style/SiteCrawler.module.scss";

const cn = className.bind(style);

const GROUPS = [
	{key: 'score_technical', label: 'Kỹ thuật & Index', icon: 'fa-light fa-gears'},
	{key: 'score_meta', label: 'Thẻ Meta', icon: 'fa-light fa-tags'},
	{key: 'score_social', label: 'Mạng xã hội', icon: 'fa-light fa-share-nodes'},
	{key: 'score_content', label: 'Nội dung', icon: 'fa-light fa-align-left'},
	{key: 'score_image', label: 'Hình ảnh', icon: 'fa-light fa-image'},
	{key: 'score_structured', label: 'Cấu trúc & Link', icon: 'fa-light fa-diagram-project'},
];

export const scoreColor = (v) => (v >= 75 ? '#52c41a' : v >= 50 ? '#faad14' : '#f5222d');

/**
 * Điểm SEO trung bình toàn site theo 6 nhóm (thanh tiến độ). Vòng điểm tổng nằm ở
 * ReportSummary (hero) nên ở đây chỉ hiển thị lưới 6 nhóm.
 */
function SiteScoreCards({crawl}) {

	if (!crawl) return null;

	return (
		<div className={cn('scoreCards')}>
			{GROUPS.map((g) => {
				const v = Number(crawl[g.key] || 0);
				return (
					<div key={g.key} className={cn('scoreCard')}>
						<div className={cn('label')}>{g.label}</div>
						<div className={cn('value')} style={{color: scoreColor(v)}}>{v}<span className={cn('outOf')}>/100</span></div>
						<div className={cn('bar')}>
							<span style={{width: `${v}%`, background: scoreColor(v)}} />
						</div>
					</div>
				);
			})}
		</div>
	);
}

export default SiteScoreCards;
